/**
 * CursorCustomizerFeature - Custom cursor styles
 */
import BaseFeature from './BaseFeature.js';

export default class CursorCustomizerFeature extends BaseFeature {
    enable() {
        super.enable();
        this.addBodyClass('dhA11y-custom-cursor');
    }

    disable() {
        super.disable();
        this.removeBodyClass('dhA11y-custom-cursor');
    }
}
